import { getNodeById } from "../../../../nodeSelector";
import * as nodeUtils from "../../../../utils/nodeUtils";
import * as systemUtils from "../../../../utils/systemUtils";

const _tagNodeTarget = "nodeTarget";
const _tagNodeTargetIndirect = "nodeTargetIndirect";
const _tagNodeReference = "nodeReference";
const _tagNodeReferenceIndirect = "nodeReferenceIndirect";
const _tagUuidTarget = "uuidTarget";
const _tagUuidTargetIndirect = "uuidTargetIndirect";
const _tagUuidReference = "uuidReference";
const _tagUuidReferenceIndirect = "uuidReferenceIndirect";
const _tagPayload = "refDesc";

//--------------------------------------------------------------------------------

export const getParameterReferences = (root, node) => {
  const _results = {};

  const _nodeTarget = updateTargetDirect(root, node);

  if (_nodeTarget) {
    _results[_tagNodeTarget] = _nodeTarget;
  }

  const _nodeTargetIndirect = updateTargetIndirect(root, node);

  if (_nodeTargetIndirect) {
    _results[_tagNodeTargetIndirect] = _nodeTargetIndirect;
  }

  const _nodeReference = updateReferenceDirect(root, node);

  if (_nodeReference) {
    _results[_tagNodeReference] = _nodeReference;
  }

  const _nodeReferenceIndirect = updateReferenceIndirect(root, node);

  if (_nodeReferenceIndirect) {
    _results[_tagNodeReferenceIndirect] = _nodeReferenceIndirect;
  }

  _results[_tagPayload] = describeReferences(_results);

  return _results;
};

export const processParameterReferences = (
  references,
  funTarget = () => {},
  funTargetIndirect = () => {},
  funReference = () => {},
  funReferenceIndirect = () => {}
) => {
  let handler;

  handler = references[_tagNodeTarget];
  if (handler) {
    funTarget(handler);
  }

  handler = references[_tagNodeTargetIndirect];
  if (handler) {
    handler.forEach(funTargetIndirect);
  }

  handler = references[_tagNodeReference];
  if (handler) {
    handler.forEach(funReference);
  }

  handler = references[_tagNodeReferenceIndirect];
  if (handler) {
    handler.forEach(funReferenceIndirect);
  }
};

export const trimIdReference = (root, node) => {
  const _references = nodeUtils.getIdReferences(node);
  const _referencesVoid = [];

  _references.forEach((e) => {
    const { data: _nodeTarget } = getNodeById(root, e);

    if (!_nodeTarget) {
      _referencesVoid.push(e);
    }
  });

  _referencesVoid.forEach((e) => {
    nodeUtils.removeIdReference(node, e);
  });
};

//--------------------------------------------------------------------------------

const updateTargetDirect = (root, node) => {
  const _idTarget = nodeUtils.getIdTarget(node);

  if (!_idTarget) {
    return null;
  }

  const { data: _nodeTarget } = getNodeById(root, _idTarget);

  if (!_nodeTarget) {
    return null;
  }

  return { src: node, dst: _nodeTarget };
};

const updateTargetIndirect = (root, node) => {
  const _nodeTargetIndirect = [];

  const fun = (e) => {
    const _nodeTarget = updateTargetDirect(root, e);

    if (_nodeTarget) {
      _nodeTargetIndirect.push(_nodeTarget);
    }
  };

  nodeUtils.visitAllParameters(node, fun);

  return _nodeTargetIndirect.length > 0 ? _nodeTargetIndirect : null;
};

const updateReferenceDirect = (root, node) => {
  const _nodeReference = [];

  const _id = nodeUtils.getID(node);

  const fun = (e) => {
    const _idTarget = nodeUtils.getIdTarget(e);

    if (!_idTarget) {
      return;
    }

    const { data: _nodeTarget } = getNodeById(root, _idTarget);

    if (!_nodeTarget) {
      return;
    }

    if (_idTarget === _id) {
      _nodeReference.push({ src: e, dst: _nodeTarget });
    }
  };

  nodeUtils.visitAllParameters(root, fun);

  return _nodeReference.length > 0 ? _nodeReference : null;
};

const updateReferenceIndirect = (root, node) => {
  const _nodeReferenceIndirect = [];

  const fun = (e) => {
    const _nodeReference = updateReferenceDirect(root, e);

    if (_nodeReference && _nodeReference.length > 0) {
      _nodeReferenceIndirect.push(..._nodeReference);
    }
  };

  nodeUtils.visitAllParameters(node, fun);

  return _nodeReferenceIndirect.length > 0 ? _nodeReferenceIndirect : null;
};

//--------------------------------------------------------------------------------

const describeReferences = (references) => {
  const _results = {};

  const funTarget = (e) => nodeUtils.getUUID(e.dst);
  const funReference = (e) => nodeUtils.getUUID(e.src);

  let handler;

  handler = references[_tagNodeTarget];
  if (handler) {
    _results[_tagUuidTarget] = funTarget(handler);
  }

  handler = references[_tagNodeTargetIndirect];
  if (handler) {
    _results[_tagUuidTargetIndirect] = systemUtils.removeDuplicates(handler.map(funTarget));
  }

  handler = references[_tagNodeReference];
  if (handler) {
    _results[_tagUuidReference] = systemUtils.removeDuplicates(handler.map(funReference));
  }

  handler = references[_tagNodeReferenceIndirect];
  if (handler) {
    _results[_tagUuidReferenceIndirect] = systemUtils.removeDuplicates(handler.map(funReference));
  }

  return _results;
};
